import get from 'hs-lodash/get';
import { ORDER_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import HighlightCard from '../HighlightCard/HighlightCard';
import OrderHighlightDetails from './OrderHighlightDetails';
import OrderHighlightActions from './OrderHighlightActions';
import OrderHighlightTitle from './OrderHighlightTitle';
import useOrderHighlightProperties from '../../hooks/useOrderHighlightProperties';
import { useAllPipelinesQuery } from '../../hooks/useAllPipelinesQuery';
import { ORDER_HIGHLIGHT_CARD } from '../../constants/dataTestIds';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const OrderHighlight = ({
  objectId
}) => {
  const {
    data,
    loading,
    error
  } = useOrderHighlightProperties(objectId);
  const {
    pipelines,
    loading: pipelinesLoading,
    error: pipelinesError
  } = useAllPipelinesQuery({
    objectTypeId: ORDER_TYPE_ID
  });
  const errorMessage = error || pipelinesError ? 'Something went wrong' : '';
  const orderTitle = get(data, ['properties', 'hs_order_name', 'value']) || 'No title';
  const properties = get(data, ['properties']);
  return /*#__PURE__*/_jsxs(HighlightCard, {
    "data-test-id": ORDER_HIGHLIGHT_CARD,
    loading: loading || pipelinesLoading,
    errorMessage: errorMessage,
    children: [/*#__PURE__*/_jsx(OrderHighlightActions, {
      objectId: objectId
    }), /*#__PURE__*/_jsx(OrderHighlightTitle, {
      title: orderTitle
    }), /*#__PURE__*/_jsx(OrderHighlightDetails, {
      properties: properties,
      pipelines: pipelines
    })]
  });
};
export default OrderHighlight;